import React from 'react';
import Icon, { IconProps } from '../Icon';

const TickIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.16297 8C3.10826 8.00003 3.05409 7.98817 3.00355 7.9651C2.953 7.94204 2.90707 7.90822 2.86838 7.86557L0.116908 4.83062C0.0410451 4.74399 -0.000933148 4.62796 1.57434e-05 4.50753C0.000964635 4.38709 0.0447643 4.27189 0.121981 4.18672C0.199198 4.10156 0.303654 4.05325 0.412851 4.0522C0.522048 4.05116 0.627249 4.09746 0.705796 4.18113L3.16297 6.89118L9.28895 0.134425C9.32766 0.0917783 9.3736 0.0579581 9.42415 0.0348935C9.47471 0.0118289 9.52888 -2.83842e-05 9.58359 5.10222e-08C9.6383 2.84862e-05 9.69247 0.011941 9.743 0.0350582C9.79354 0.0581754 9.83945 0.0920442 9.87812 0.134731C9.91679 0.177417 9.94745 0.228086 9.96836 0.283844C9.98927 0.339601 10 0.399356 10 0.459695C9.99997 0.520034 9.98917 0.579777 9.96821 0.635513C9.94725 0.691248 9.91654 0.741884 9.87784 0.784531L3.45727 7.86526C3.37924 7.95143 3.27338 7.99989 3.16297 8Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default TickIcon;
